// extracted by mini-css-extract-plugin
export var cartIcon = "_mv-0";
export var cartIconContainer = "_mv-1";